import { ScanLine, Play } from 'lucide-react';
import { useIntegrationMode } from '../../contexts/IntegrationModeContext';

const FirstRunBanner = ({ app, onExploreDemo, onLoadSchedule, onActivate }) => {
  const { dismissFirstRun } = useIntegrationMode();

  const configs = {
    lumina_provider: {
      text: 'This is a demo patient \u2014 your real patients will look like this once your schedule is loaded.',
      primaryLabel: 'Load my schedule',
      primaryIcon: ScanLine,
      secondaryLabel: 'Explore the demo first',
      onPrimary: onLoadSchedule,
      onSecondary: () => { onExploreDemo?.(); dismissFirstRun('lumina'); },
    },
    lumina_ma: {
      text: 'This is what a ready morning looks like. Scan your schedule to populate today\u2019s patients.',
      primaryLabel: 'Scan today\u2019s schedule to get started',
      primaryIcon: ScanLine,
      secondaryLabel: 'Explore the demo',
      onPrimary: onLoadSchedule,
      onSecondary: () => { onExploreDemo?.(); dismissFirstRun('lumina_ma'); },
    },
    revq: {
      text: 'This is a demo claim \u2014 see how RevQ validates coding, flags issues, and suggests fixes. Connect Lumina or scan a superbill to start processing real claims.',
      primaryLabel: 'Scan a superbill',
      primaryIcon: ScanLine,
      secondaryLabel: 'Explore the demo',
      onPrimary: onLoadSchedule,
      onSecondary: () => { onExploreDemo?.(); dismissFirstRun('revq'); },
    },
    echo: {
      text: 'This is how Echo handles routine calls. Activate Echo to start.',
      primaryLabel: 'Activate Front Desk Agent',
      primaryIcon: Play,
      secondaryLabel: 'Watch the demo first',
      onPrimary: onActivate,
      onSecondary: () => { onExploreDemo?.(); dismissFirstRun('echo'); },
    },
  };

  const c = configs[app];
  if (!c) return null;
  const PrimaryIcon = c.primaryIcon;

  return (
    <div
      style={{
        background: '#fffbeb',
        border: '0.5px solid #fde68a',
        borderRadius: 10,
        padding: '12px 16px',
        marginBottom: 16,
      }}
      data-testid={`first-run-banner-${app}`}
    >
      <p style={{ fontSize: 12, color: '#92400e', margin: 0, lineHeight: 1.6 }}>{c.text}</p>
      <div className="flex items-center gap-2 mt-3">
        <button
          onClick={c.onPrimary}
          className="flex items-center gap-1.5"
          style={{
            height: 30,
            padding: '0 14px',
            borderRadius: 6,
            background: '#111111',
            color: '#ffffff',
            fontSize: 12,
            fontWeight: 500,
            border: 'none',
            cursor: 'pointer',
          }}
          data-testid="first-run-primary-cta"
        >
          <PrimaryIcon style={{ width: 13, height: 13 }} />
          {c.primaryLabel}
        </button>
        <button
          onClick={c.onSecondary}
          style={{
            height: 30,
            padding: '0 14px',
            borderRadius: 6,
            background: 'transparent',
            color: '#92400e',
            fontSize: 12,
            fontWeight: 500,
            border: '1px solid #fde68a',
            cursor: 'pointer',
          }}
          data-testid="first-run-secondary-cta"
        >
          {c.secondaryLabel}
        </button>
      </div>
    </div>
  );
};

export default FirstRunBanner;
